<template>
	<v-dialog v-model="dialog" persistent max-width="700px">
		<v-card>
			<v-toolbar flat dense cad>
				<v-toolbar-title class="subheading">Edit Deliverable</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<v-container grid-list-lg class="pa-0">
					<v-layout row wrap>
						<v-flex lg7>
							<v-text-field ref="outcome"
                            v-model="form.outcome" 
                            label="Deliverable"
                            :error-messages="outcomeErrors"></v-text-field>
						</v-flex>
						<v-flex lg5>
							<v-card flat color="grey lighten-3">
								<v-card-title class="pb-0">
									<span class="subheading grey--text">Settings</span>
								</v-card-title>

								<v-card-text>
									<v-divider />
									<v-switch v-model="form.isPerformanceReviewDiscussionPoint" append-icon="forum" label="Discuss this deliverable in Performance Reviews" persistent-hint :hint="discussInPerformanceReviewsHint"></v-switch>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancel">Cancel</v-btn>
				<v-btn color="primary" flat @click="onSubmit">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
    import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			outcome: {
				type: Object,
				default: () => ({
					id: null,
					outcome: '',
					isPerformanceReviewDiscussionPoint: true
				})
			},
			dialog: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				form: {
					id: this.outcome.id,
					outcome: this.outcome.outcome,
					isPerformanceReviewDiscussionPoint: this.outcome.isPerformanceReviewDiscussionPoint
				}
			};
		},
        mounted() {
            this.$nextTick(() => {
                this.$refs.outcome.focus();
            });
        },
        mixins: [validationMixin],
		validations: {
			form: {
				outcome: { required }
			}
		},
        computed: {
            outcomeErrors() {
				const errors = [];
				if (!this.$v.form.outcome.$dirty) return errors;
				!this.$v.form.outcome.required && errors.push('Outcome is required.');
				return errors;
			},
            discussInPerformanceReviewsHint() {
				return "Key Duty deliverables can be pulled in as discussion points in performance reviews. This setting allows you to exclude certain deliverables from being used in reviews.";
			}
        },
		methods: {
			onSubmit() {
				this.$v.form.$touch();

				if (!this.$v.form.$invalid) {
                    this.$emit('onSubmit', this.form);
				}				
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>